module.exports = __webpack_public_path__ + "static/media/doctor-11.dc6851a1.jpg";